import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-color-grp',
  templateUrl: './color-grp.component.html',
  styleUrls: ['./color-grp.component.css']
})
export class ColorGrpComponent implements OnInit {
    public colorGrpId: string;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.colorGrpId = this.stateService.getStateParams()['colorgrp_id'];
    }

    private async loadEdit() {
        if (!!this.colorGrpId) {
            this.edit = (await this.datatask.Post(1208, { colorgrp_id: this.colorGrpId }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(1209, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    colorgrp_id: string;
    colorgrp_name: string;
    sortorder: string;
}
